"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = watchRatings;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _utils = require("@dom/utils");

var _ratings = require("../actions/ratings");

var _types = require("../actions/types");

var _utils2 = require("../utils");

var _marked =
/*#__PURE__*/
_regenerator["default"].mark(watchRatings),
    _marked2 =
/*#__PURE__*/
_regenerator["default"].mark(sendRatings),
    _marked3 =
/*#__PURE__*/
_regenerator["default"].mark(fetchRatings);

function watchRatings() {
  return _regenerator["default"].wrap(function watchRatings$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.all)([(0, _effects.takeLatest)(_types.SEND_RATINGS, sendRatings), (0, _effects.takeLatest)(_types.FETCH_RATINGS, fetchRatings)]);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/**
 * @param  {Object} ratings
 * @param  {String}  origin
 *
 * ratings has rating title as key and rating value as number
 * origin is the source where the action is fired.
 * origin could be trek(trekOverview), lodge(ldogeDetail) or profile
 */


function sendRatings(_ref) {
  var ratings, origin, token, url, _ref2, user;

  return _regenerator["default"].wrap(function sendRatings$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          ratings = _ref.ratings, origin = _ref.origin, token = _ref.token;
          _context2.prev = 1;
          url = _utils.endpoints[origin].ratings(id[origin]());
          _context2.next = 5;
          return (0, _effects.select)();

        case 5:
          _ref2 = _context2.sent;
          user = _ref2.user;

          if (!user.userId) {
            _context2.next = 12;
            break;
          }

          _context2.next = 10;
          return (0, _effects.call)(_utils.api.post, url, ratings);

        case 10:
          _context2.next = 14;
          break;

        case 12:
          _context2.next = 14;
          return (0, _effects.call)(_utils.api.postAsAGuest, url, ratings, token);

        case 14:
          _context2.next = 19;
          break;

        case 16:
          _context2.prev = 16;
          _context2.t0 = _context2["catch"](1);
          console.log(_context2.t0);

        case 19:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 16]]);
}

function fetchRatings(_ref3) {
  var origin, _url, _ref4, data;

  return _regenerator["default"].wrap(function fetchRatings$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          origin = _ref3.origin;
          _context3.prev = 1;
          _url = _utils.endpoints[origin].ratings(id[origin]());
          _context3.next = 5;
          return (0, _effects.call)(_utils.api.get, _url);

        case 5:
          _ref4 = _context3.sent;
          data = _ref4.data;
          _context3.next = 9;
          return (0, _effects.put)((0, _ratings.storeRatings)(data, origin));

        case 9:
          _context3.next = 14;
          break;

        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](1);
          console.log(_context3.t0);

        case 14:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 11]]);
}

var id = {
  treks: _utils2.getTrekIdFromUrl,
  lodge: _utils2.getLodgeIdFromUrl,
  profile: _utils2.getUserIdFromUrl,
  flights: function flights() {
    return 'f8016c413194';
  }
};